<template>
    <div class="home">
        <!-- 原搜索区域保留但隐藏，当页面滚动到顶部时显示 -->
        <div class="search-area">
            <div class="search-box">
                <el-input placeholder="请输入关键字" v-model="searchKeyword" @keyup.enter.native="handleSearch">
                    <el-button slot="append" class="search-btn" @click="handleSearch">搜索</el-button>
                </el-input>
            </div>
            <div class="hot-tags">
                <label> 热词：</label>
                <el-tag size="small" v-for="(tag, index) in hotTagsList" :key="index" @click="selectHotTag(tag)">{{
                    tag
                }}</el-tag>
            </div>
        </div>

        <!-- 热门推荐区域 -->
        <div class="category">
            <div class="category-header">
                <div class="category-title">热门推荐</div>
                <div class="more-link" @click="moreLinkClick('hot')">查看更多 <i class="el-icon-arrow-right"></i></div>
            </div>
            <material-list @listItemClick="listItemClick" :data="hotMaterials.slice(0, 6)"></material-list>
        </div>

        <!-- 工程类区域 -->
        <div class="category" v-for="category in categoryMenuList" :key="category.value">
            <div class="category-header">
                <div class="category-title">{{ category.label }}</div>
                <div class="more-link" @click="moreLinkClick(category.value)">
                    查看更多 <i class="el-icon-arrow-right"></i>
                </div>
            </div>
            <div class="sub-category-tabs">
                <span
                    class="tab"
                    v-for="subCategory in category.children.slice(0, 5)"
                    :class="{ active: category.activeTab === subCategory.value }"
                    :key="subCategory.value"
                    @click="handleTabClick(category, subCategory.value)"
                >
                    {{ subCategory.label }}
                </span>
            </div>
            <material-list
                @listItemClick="listItemClick"
                :key="category.activeTab"
                :data="category.list"
            ></material-list>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MaterialList from './components/material-list.vue';
import { getMaterialTypesData } from '@/util/util';

export default {
    name: 'ApplicationCenterHome',
    components: {
        MaterialList
    },
    data() {
        return {
            searchKeyword: '',
            activeEngineeringTab: 'decoration',
            activeServiceTab: 'catering',
            hotTagsList: [],
            categoryMenuList: [],
            hotMaterials: []
        };
    },
    computed: {
        ...mapGetters(['userInfo'])
    },
    mounted() {
        // 热词
        this.getHotKeywprds();
        // 热门推荐
        this.getList(
            {
                typecode: 'hot'
            },
            (list) => {
                this.hotMaterials = list;
            }
        );
        // 素材库
        this.getMaterialLibrary();
    },
    methods: {
        ...mapActions(['openMaterialDetailDialog']),
        // 热词
        getHotKeywprds: function() {
            this.$Api
                .getApplicationCenterHotKeywprds({
                    limit: 10
                })
                .then(({ hottest }) => {
                    this.hotTagsList = hottest;
                });
        },
        // 选择热门标签
        selectHotTag(tag) {
            this.searchKeyword = tag;
            this.$emit('search', tag);
        },

        // 素材库菜单
        getMaterialLibrary: function() {
            this.$Api.getMaterialTypes().then((data) => {
                let list = getMaterialTypesData(data);
                this.categoryMenuList = list.map((e) => {
                    return {
                        activeTab: e.children[0].value,
                        list: [],
                        ...e
                    };
                });
                this.categoryMenuList.forEach((e) => {
                    this.handleTabClick(e, e.children[0].value);
                });
            });
        },
        getList(params, cb) {
            this.$Api
                .getApplicationCenterList({
                    searchtext: '',
                    pagesize_lowerlimit: '',
                    pagesize_upperlimit: '',
                    shopguid: '',
                    consumer: {
                        userguid: '',
                        consumerule: ''
                    },
                    sortingrule: '',
                    pageindex: 0,
                    pagesize: 6,
                    ...params
                })
                .then(({ materiallist }) => {
                    cb && cb(materiallist);
                });
        },
        // 处理tab点击
        handleTabClick(category, typecode) {
            category.activeTab = typecode;
            this.getList(
                {
                    typecode
                },
                (list) => {
                    category.list = list;
                }
            );
        },
        // 搜索方法
        handleSearch() {
            if (this.searchKeyword) {
                this.$Api
                    .setApplicationCenterHotKeywprds({
                        keyword: this.searchKeyword,
                        userguid: this.userInfo.userguid
                    })
                    .then(() => {
                        this.$router.push({
                            name: 'ApplicationCenterInfo',
                            query: { keyword: this.searchKeyword }
                        });
                    });
            }
        },
        // 更多点击
        moreLinkClick(parenttypecode) {
            this.$router.push({
                name: 'ApplicationCenterInfo',
                query:
                    parenttypecode === 'hot'
                        ? {
                              parenttypecode: '',
                              sortingrule: 'Hottest'
                          }
                        : { parenttypecode: parenttypecode }
            });
        },
        // 列表点击
        listItemClick(data) {
            this.openMaterialDetailDialog(data.materialguid);
        }
    }
};
</script>

<style scoped lang="scss">
@import './style/common.scss';
@import './style/application-center-home.scss';
</style>
